export default "__VITE_ASSET__CpTDrXpx__"